export const SITE_URL = 'https://www.bybid9.org';

export const HOME_PAGE_SEO = {
  title: 'Bybid9 | Play Online Pokies Australia | Welcome Bonus & Fast Withdrawals',
  description:
    'Bybid9 is a leading jackpot casino platform offering premium slot games, fast payouts, and smooth gameplay. Enjoy high jackpot wins, top providers, and a seamless online casino experience designed for modern players.',
  canonicalPath: '/',
} as const;

export const BLOG_PAGE_SEO = {
  title: 'Bybid9 Blog | Online Casino Australia | TPA, Pokies & Game Providers',
  description:
    'Bybid9 blog for Australian players: Trusted Pokies Australia (TPA) reviews, football bet, online pokies guides, and top game providers including JILI, BNG, Pragmatic Play, VPower, MEGA888 and BT Gaming.',
  canonicalPath: '/blog',
} as const;

type PageSeo = {
  title: string;
  description: string;
  canonicalPath: string;
};

function upsertMeta(
  selector: string,
  attributes: Record<string, string>,
  content: string,
) {
  let element = document.querySelector<HTMLMetaElement>(selector);
  if (!element) {
    element = document.createElement('meta');
    Object.entries(attributes).forEach(([key, value]) => {
      element!.setAttribute(key, value);
    });
    document.head.appendChild(element);
  }
  element.setAttribute('content', content);
}

function upsertCanonical(href: string) {
  let element = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
  if (!element) {
    element = document.createElement('link');
    element.setAttribute('rel', 'canonical');
    document.head.appendChild(element);
  }
  element.setAttribute('href', href);
}

export function applyPageSeo({ title, description, canonicalPath }: PageSeo) {
  document.title = title;

  upsertMeta('meta[name="description"]', { name: 'description' }, description);
  upsertMeta('meta[property="og:title"]', { property: 'og:title' }, title);
  upsertMeta('meta[property="og:description"]', { property: 'og:description' }, description);
  upsertMeta('meta[property="og:url"]', { property: 'og:url' }, `${SITE_URL}${canonicalPath}`);
  upsertMeta('meta[name="twitter:title"]', { name: 'twitter:title' }, title);
  upsertMeta('meta[name="twitter:description"]', { name: 'twitter:description' }, description);
  upsertCanonical(`${SITE_URL}${canonicalPath}`);
}
